import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import AuthLayout, { authStyles } from "@/components/AuthLayout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setEmailSent(true);
      toast.success("Password reset email sent!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      {/* Heading */}
      <div className="auth-head" style={authStyles.heading}>Reset your password</div>
      <div className="auth-head" style={{ ...authStyles.sub, marginBottom: 24 }}>
        Enter your email and we&rsquo;ll send a reset link. It&rsquo;s valid for 1 hour.
      </div>

      {emailSent ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "30px 20px",
            border: "1px solid rgba(103,198,180,.25)",
            background: "rgba(103,198,180,.07)",
            borderRadius: 16,
          }}
        >
          <span
            style={{
              width: 54,
              height: 54,
              borderRadius: 15,
              background: "rgba(103,198,180,.16)",
              color: "#67C6B4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 14,
            }}
          >
            <Mail className="w-[26px] h-[26px]" />
          </span>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: 17, color: "#fff" }}>
            Check your email
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,.6)", marginTop: 6, lineHeight: 1.55 }}>
            We sent a reset link to <strong style={{ color: "#fff" }}>{email}</strong>. Didn&rsquo;t get it? Check spam or{" "}
            <span className="auth-link" onClick={() => setEmailSent(false)} style={{ fontWeight: 600 }}>try again</span>.
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 13 }}>
          <div>
            <span style={authStyles.label}>Email</span>
            <input
              className="auth-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              style={authStyles.input}
              required
            />
          </div>
          <button type="submit" disabled={loading} className="auth-primary" style={{ ...authStyles.primaryBtn, opacity: loading ? 0.7 : 1 }}>
            {loading ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <span className="inline-block animate-spin rounded-full h-4 w-4 border-2 border-t-transparent" style={{ borderColor: "#0C1120", borderTopColor: "transparent" }}></span>
                Sending…
              </span>
            ) : "Send reset link"}
          </button>
        </form>
      )}

      <div style={{ textAlign: "center", fontSize: 13, color: "rgba(255,255,255,.55)", marginTop: 20 }}>
        <Link to="/login" className="auth-link" style={{ fontWeight: 600 }}>&larr; Back to sign in</Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
